import { render, staticRenderFns } from "./ParamHandler.vue?vue&type=template&id=90814c16&"
import script from "./ParamHandler.vue?vue&type=script&lang=js&"
export * from "./ParamHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports